export default __webpack_public_path__ + "static/media/skyline.2b410b27.svg";